<!-- =========================================================================================
    File Name: Profile.vue
    Description: Profile Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="sanbox-app">
    <explore></explore>
    <guide :data="guide" :key="guide.type"></guide>
    <!-- EXPLORE-CORE -->
    <div class="vx-row">
      <!-- COL 1 -->
      <div class="vx-col w-full">
        <visualizer :artefact="artefact" :key="artefact.query"></visualizer>
      </div>
      <!-- COL 2 -->
      <!-- <div class="vx-col w-full lg:w-1/4">
        <VuePerfectScrollbar :settings="settings" ref="visualizerPS">
          <div ref="visualizer">
            <quick-access :reset="filterReset"></quick-access>
          </div>
        </VuePerfectScrollbar>
      </div>-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import Guide from "./Guide.vue";
import Explore from "./Explore.vue";
// import QuickAccess from "./QuickAccess.vue";
import Visualizer from "./Visualizer.vue";

import { actionsTypes } from "../shared/state";


export default {
  data() {
    return {
      isNavOpen: false,
      type: "all",
      searchQuery: "Modern Admin",
      currentPage: 1,

      itemsPerPage: 10,
      activeSearch: null,
      filterReset: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.7
      },
      wasSidebarOpen: null,
      payload: {
          tags: [],
          dateRange: [],
          query: "",
          mode: "",
          type: "",
          res: {}
        }
    };
  },
  computed: {
    ...mapGetters({guide: "sandbox/guide", artefact: "sandbox/artefact", isLoading: "sandbox/isLoading"})
  },
  methods: {
    init() {
      this.$store.dispatch('sandbox/'+ actionsTypes.FETCH_SANDBOX_GUIDE, this.payload);
      // this.$store.dispatch('sandbox/'+ actionsTypes.FETCH_SANDBOX_ARTEFACT, this.payload);
    },
  },
  components: {
    VuePerfectScrollbar,
    Guide,
    Explore,
    Visualizer
  },
  created() {
    // this.$refs.visualizerPS.$el.scrollTop = this.$refs.visualizer.scrollHeight;
  },
  mounted() {
    this.wasSidebarOpen = this.$store.state.reduceButton;
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    // this.$store.dispatch('sandbox/'+RESET_SANDBOX_STATE);
    this.init();
    this.filterReset = true;
  },
  beforeDestroy() {
    if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  },
  watch: {
    "$store.state.AppScopeTrack"(val) {
      this.init();
    },
  },
};
</script>